import { defineStore } from 'pinia';
import { reactive } from 'vue';

export const useLicenseStore = defineStore('license-info-form', () => {
  const state = reactive({
    /** 对公账户名 */
    name: undefined,
    /** 纳税人识别号 */
    creditCode: undefined,
  });

  function updateState(type: string, name: string) {
    if (type === 'name') {
      state.name = name;
    } else if (type === 'creditCode') {
      state.creditCode = name;
    }
  }

  return {
    state,
    updateState,
  };
});

export default useLicenseStore;
